module.exports = __webpack_public_path__ + "img/t3-gray.4c014599.png";